import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { withElementWrapper } from "../withElementWrapper";

import "./block-quote.m.css";
import { SvgIconHandler } from "../../../../../components/atoms/SvgIconHandler";

export const BlockQuoteBase = ({ element }) => {
  const { content, attribution } = get(element, ["metadata"]);
  if (!content) return null;

  return (
    <div className="arrow-component arr--block-quote" data-test-id="blockquote" styleName="blockquote">
      <div styleName="quote-wrapper">
        <div styleName="icon-border">
         {/* <SvgIconHandler type="blockquote" width="42" height="35" viewBox="0 0 42 35" /> */}
         <i/>
        </div>
        <div styleName="wrapper">
          <div styleName="content" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
        {attribution && <div styleName="attribution" dangerouslySetInnerHTML={{ __html: attribution }} />}
      </div>
    </div>
  );
};

BlockQuoteBase.propTypes = {
  element: PropTypes.shape({
    metadata: PropTypes.shape({ content: PropTypes.string, attribution: PropTypes.string }),
  }),
};

export const BlockQuote = withElementWrapper(BlockQuoteBase);
